<template>
  <a-cascader v-model="selectedAnimal" :options="animal" :load-data="loadAnimalData" @change="onChange" change-on-select :placeholder="placeholder" />
</template>

<script>
import { coreMixins } from '@/Utils/core'
export default {
  name: 'AnimalSelect',
  mixins: [coreMixins],
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '选择动物'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      animal: [],
      selectedAnimal: []
    }
  },
  watch: {
    value(v) {
      // console.log('value', v)
      if (!v) {
        this.selectedAnimal = []
      }
      // console.log(this.selectedAnimal)
    }
  },
  async mounted() {
    const res = await this.getAnimal()
    if (res[0].id) {
      const animaldata = await this.getAnimal({ parentId: res[0].id })
      this.animal = animaldata.map(this.mapFilter)
    }
  },

  methods: {
    onChange(val) {
      this.value = [...val].pop()
      this.$emit('change', this.value)
      this.$emit('select', val)
    },
    mapFilter(i) {
      return {
        ...i,
        label: i.name,
        value: i.id,
        isLeaf: !i.hasChildren
      }
    },

    async loadAnimalData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const { value: parentId } = targetOption
      const res = await this.getAnimal({ parentId })
      targetOption.loading = false
      targetOption.children = res.map(this.mapFilter)
      this.animal = [...this.animal]
    }
  }
}
</script>
